export const STEPS_BY_COUNTRY = {
  CHL: ['step1', 'step2', 'step3'],
  ARG: ['step1', 'step2', 'step3'],
  COL: ['step1', 'step2', 'step3'],
  PER: ['step1', 'step2', 'step3'],
  BRA: ['step1', 'step2', 'step3'],
  MEX: ['step1', 'step2', 'step3'],
}
